import React, {useContext, useEffect} from "react"
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import {FormattedMessage} from "react-intl";
import {getDocumentURL} from "../handler/ParentDataHandler";
import {getBaseUrl, getRefreshInterval} from "../util/Util";
import Link from "@amzn/meridian/link";
import AssociateFilterWrapper from "./AssociateFilterWrapper";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const AssociatePerformance = () => {
    const {states} = useContext(AssociateFilterContext)
    const {viewModel, dispatch} = useContext(AssociatePerformanceContext);
    const {configViewModel} = useContext(CapabilityContext);
    const {spacingInset_shorthand3} = useDeviceLayout();

    const getAssociateLink = (loginId) => {
        getDocumentURL().then(documentUrl => {
            const searchURL = new URL(documentUrl.toString().replace('associatepick', 'search'));

            const startDate = new Date();
            startDate.setHours(0,0,0,0);
            const endDate = new Date();
            endDate.setDate(startDate.getDate() +1);
            endDate.setHours(0,0,0,0);

            const optionsObj = {
                "type": "ASSOCIATE",
                "startDate": startDate.getTime(),
                "endDate": endDate.getTime(),
            }

            const shareableLink = "/detailPage/" + loginId + '/' + JSON.stringify(optionsObj);
            searchURL.searchParams.set("shareableLink", shareableLink);
            window.open(searchURL.href, "_blank")
        });
    };

    const getData = (baseUrl) => {
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch, baseUrl, stationConfig: configViewModel.stationConfig}});
    }

    useEffect(() => {
        getDocumentURL().then(result => {
            const baseUrl = getBaseUrl(result);
            getData(baseUrl)
            const interval = setInterval(() => {
                getData(baseUrl)
            }, getRefreshInterval(configViewModel.stationConfig));
            return () => clearInterval(interval);
        });
    }, []);

    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }

    const sortedAssociatePerformance = [...viewModel.associatePerformance];
    sortedAssociatePerformance && sortedAssociatePerformance.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    return (
        <div>
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset={spacingInset_shorthand3}>
                <div>
                    <Heading level={2} type="h400" alignment="left">
                        <FormattedMessage id="associate.associates" defaultMessage="Associates"/>
                    </Heading>
                    <AssociateFilterWrapper/>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table headerRows={1} spacing="small"
                               fixHeaderRows={true}
                               fixHeaderRowsFullWidth={true}
                               headerColumns={1}
                               stickyHeaderColumn={true}
                               sortColumn={viewModel.sortPref.column}
                               sortDirection={viewModel.sortPref.direction}
                               onSort={onSort}>
                            <TableRow>
                                <TableCell sortColumn="alias">
                                    <FormattedMessage id="associate.associate" defaultMessage="Associate"/>
                                </TableCell>
                                <TableCell sortColumn="pph" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.pph" defaultMessage="PPH"/>
                                </TableCell>
                                <TableCell sortColumn="hourSpent" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.hours" defaultMessage="Hours"/>
                                </TableCell>
                                <TableCell sortColumn="packageHandled" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.total_packages" defaultMessage="Total Packages"/>
                                </TableCell>
                                <TableCell sortColumn="active">
                                    <FormattedMessage id="associate.active" defaultMessage="Active"/>
                                </TableCell>
                                <TableCell sortColumn="location">
                                    <FormattedMessage id="associate.location" defaultMessage="Location"/>
                                </TableCell>
                            </TableRow>
                            {sortedAssociatePerformance.map(associate => (
                                (states.length === 0 || states.includes(associate.active)) ? (
                                    <TableRow key={associate.alias}>
                                        <TableCell>
                                            <Link onClick={() => getAssociateLink(associate.loginId)} type="secondary"
                                                  target="_blank" rel="noreferrer noopener">
                                                {associate.alias}
                                            </Link>
                                        </TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.pph}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.hourSpent}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.packageHandled}</TableCell>
                                        <TableCell>{associate.active}</TableCell>
                                        <TableCell>{associate.location}</TableCell>
                                    </TableRow>
                                ) : null
                            ))}

                        </Table>
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default AssociatePerformance


// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociatePerformance.js